import * as THREE from "three";
import { scene } from "./scene";
import { ControlFunction } from "./controlFunction";
import { progressbar } from "./progressbar";

const texture_loader = new THREE.TextureLoader();

const loadMemes = () => {
    const promiseMemes = new Promise((resolve) => {
        // Caricamento texture dei meme
        const meme1Tex = texture_loader.load("office/textures/meme-ai1.jpg");
        const meme2Tex = texture_loader.load("office/textures/meme-ai2.jpg");

        const geometry = new THREE.PlaneGeometry(1.4, 2.0);
        geometry.rotateY(-Math.PI);

        // Valore per scurire i meme (più basso è, più sono scuri)
        const memeColor = 0xcccccc;

        // Primo meme
        const meme1 = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({
            map: meme1Tex,
            color: memeColor
        }));
        meme1.position.set(-4.474468661385062, 2.5, 10.111067627774979); // Posizionato verso il muro posteriore
        meme1.userData.interactive = true;
        meme1.userData.tooltipText = "Open Meme AI";
        meme1.userData.isMeme = true;
        meme1.userData.imageUrl = "office/textures/meme-ai1.jpg";
        scene.add(meme1);
        // ControlFunction(meme1);

        // Secondo meme
        const meme2 = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({
            map: meme2Tex,
            color: memeColor
        }));
        meme2.position.set(-6.274094922844258, 2.200271006392248, 10.12042104816414);
        meme2.userData.interactive = true;
        meme2.userData.tooltipText = "Open Meme AI";
        meme2.userData.isMeme = true;
        meme2.userData.imageUrl = "office/textures/meme-ai2.jpg";
        scene.add(meme2);
        //ControlFunction(meme2);

        resolve([meme1, meme2]);
        progressbar();
    });
    return promiseMemes;
};

export { loadMemes };
